import React from 'react';
import { EmojiContextProvider } from './EmojiContextProvider';
/**
 * EmojiCommonProvider will provide emojiProvider to children,
 * which will be used to access Emoji Resource to find emoji, filter emoji, check if upload is supported, etc.
 *
 * Example usage:
 * const emojiResource = new EmojiResource(resourceConfig)
 * <EmojiCommonProvider emojiProvider={emojiResource} />
 */
export var EmojiCommonProvider = function EmojiCommonProvider(props) {
  if (props.emojiProvider) {
    return /*#__PURE__*/React.createElement(EmojiContextProvider, {
      emojiContextValue: {
        emoji: {
          emojiProvider: props.emojiProvider
        }
      }
    }, props.children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.children);
};